<script lang="ts" setup>
import { useObserver } from '~/composables/useObserver'

/* eslint-disable vue/no-v-html */
export type PagesContactsCallcenterData = {
    headline: string
    number: PhoneContact
    opening_hours: {
        opening_hours: string
        title: string
    }[]
}
export interface PagesContactsCallcenterProps {
    data: PagesContactsCallcenterData
    note?: string
}

const props = defineProps<PagesContactsCallcenterProps>()

const { data: gaEventData, sendEvent } = useTracker()

const handleClick = () => {
    sendEvent({
        data: {
            ...gaEventData,
            position: props.data.headline,
            title: props.data.number.international_format,
        },
    })
}

const customerSupportAvailabilityWidgetWrapper = ref<HTMLElement | null>(null)
const showCustomerSupportAvailabilityWidget = ref(false)
const observer = useObserver()

onMounted(() => {
    if (customerSupportAvailabilityWidgetWrapper.value) {
        observer(customerSupportAvailabilityWidgetWrapper.value, (isIntersecting) => {
            if (isIntersecting && !showCustomerSupportAvailabilityWidget.value) {
                showCustomerSupportAvailabilityWidget.value = true
            }
        })
    }
})

</script>

<template>
  <div class="px-4 px-md-12 py-10 py-md-15 box-shadow-1 rounded">
    <h2 class="beta text-center">
      {{ props.data.headline }}
    </h2>
    <span class="d-block alfa text-secondary text-center mb-10 mb-md-15">
      <a
        :href="`tel:${props.data.number.international_format}`"
        @click="handleClick"
      >
        {{ props.data.number.international_format }}
      </a>
    </span>

    <div class="row gy-8">
      <article
        v-for="(hour, hourIndex) in props.data.opening_hours"
        :key="`hour-${hourIndex}`"
        class="col-12 col-md-4 d-flex"
      >
        <svg
          class="d-block me-4 text-secondary flex-shrink-0"
          aria-hidden="true"
          width="16"
          height="16"
        >
          <use xlink:href="#checked" />
        </svg>

        <div>
          <strong class="d-block mb-3 fs-normal fw-normal">
            {{ hour.title }}
          </strong>
          <span class="d-flex fw-bold">
            <svg
              class="d-block me-3 text-secondary flex-shrink-0"
              aria-hidden="true"
              width="16"
              height="16"
            >
              <use xlink:href="#callcenter" />
            </svg>
            {{ hour.opening_hours }}
          </span>
        </div>
      </article>

      <div
        ref="customerSupportAvailabilityWidgetWrapper"
        class="col-12"
      >
        <LazyWidgetCustomerSupportAvailability
          v-if="showCustomerSupportAvailabilityWidget"
        />
      </div>
    </div>
  </div>
  <Typo
    v-if="props.note"
    class="mt-4"
  >
    <div
      class="text-center fs-small text-secondary"
      v-html="props.note"
    />
  </Typo>
</template>
